import Dino from './components/Dino';

export default Dino;